$(function () {
    $(document).ready(function () {
        $('.main-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.image-slideshow'
        }).on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });;

        $('.image-slideshow').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.main-image',
            focusOnSelect: true
        }).on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });;
    });
});